import { apiHolder as api, apis } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
export function mailStrDecode(mail) {
    mail = mail.replace(/(^\s*)|(\s*$)/g, '');
    const contact = mail.split(' ');
    const contactEmail = contact[contact.length - 1].replace(/<|>/g, '');
    let contactName = '';
    if (contact.length > 1) {
        contactName = contact[0].replace(/"/g, '');
    }
    return {
        contactEmail,
        contactName,
    };
}
export function mailStrListDecode(mail) {
    const res = [];
    mail.forEach(_ => _ && res.push(mailStrDecode(_).contactEmail));
    return res;
}
export function formatReceiver(currentMailTemplate) {
    var _a;
    const bcc = [];
    const cc = [];
    const to = [];
    (_a = currentMailTemplate === null || currentMailTemplate === void 0 ? void 0 : currentMailTemplate.receiver) === null || _a === void 0 ? void 0 : _a.map(_ => {
        var _a, _b, _c;
        const pushVal = `"${(_b = (_a = _.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contactName}" <${(_c = _.contactItem) === null || _c === void 0 ? void 0 : _c.contactItemVal}>`;
        if (_.mailMemberType === 'to') {
            to.push(pushVal);
        }
        else if (_.mailMemberType === 'cc') {
            cc.push(pushVal);
        }
        else if (_.mailMemberType === 'bcc') {
            bcc.push(pushVal);
        }
        return _;
    });
    return {
        bcc,
        cc,
        to,
    };
}
export function formatTemplateDetail(currentMailTemplate) {
    var _a, _b, _c;
    return Object.assign({ templateId: currentMailTemplate === null || currentMailTemplate === void 0 ? void 0 : currentMailTemplate.id, templateName: '', thumbnail: {}, content: (_b = (_a = currentMailTemplate === null || currentMailTemplate === void 0 ? void 0 : currentMailTemplate.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content, subject: (_c = currentMailTemplate === null || currentMailTemplate === void 0 ? void 0 : currentMailTemplate.entry) === null || _c === void 0 ? void 0 : _c.title }, formatReceiver(currentMailTemplate));
}
export function formatSaveTemplateReq(currentMailTemplate, mailTemplateName, templateCategory) {
    var _a, _b, _c;
    return Object.assign({ templateId: currentMailTemplate === null || currentMailTemplate === void 0 ? void 0 : currentMailTemplate.id, templateName: mailTemplateName, templateCategory, content: (_b = (_a = currentMailTemplate === null || currentMailTemplate === void 0 ? void 0 : currentMailTemplate.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content, subject: (_c = currentMailTemplate === null || currentMailTemplate === void 0 ? void 0 : currentMailTemplate.entry) === null || _c === void 0 ? void 0 : _c.title }, formatReceiver(currentMailTemplate));
}
export function getTemplatesDefaultData() {
    const originData = mailApi.doBuildEmptyMailEntryModel({
        contact: [],
        mailType: 'common',
        writeType: 'common',
    });
    originData.id = '';
    return Object.assign(Object.assign({}, originData), { status: {
            cc: false,
            bcc: false,
            showContact: false,
            keyword: '',
            init: false,
            conferenceShow: false,
            conferenceSetting: true,
        }, focusTitle: false });
}
export async function formatViewMail(templateData) {
    const MailEntryModel = mailApi.doBuildEmptyMailEntryModel({
        title: templateData.subject,
        mailType: 'common',
        writeType: 'common',
    });
    const mailContentModel = Object.assign(Object.assign({}, MailEntryModel), { status: {
            cc: false,
            bcc: false,
            showContact: false,
            keyword: '',
            init: false,
            conferenceShow: false,
            conferenceSetting: true,
        }, focusTitle: false });
    mailContentModel.entry.content.content = templateData.content;
    mailContentModel.id = templateData.templateId;
    const contractItemByEmail = templateData.to && templateData.to.length > 0 ? mailApi.getContractItemByEmail(mailStrListDecode(templateData.to), 'to') : Promise.resolve([]);
    const ccContactItemByEmail = templateData.cc && templateData.cc.length > 0 ? mailApi.getContractItemByEmail(mailStrListDecode(templateData.cc), 'cc') : Promise.resolve([]);
    const bccContactItemByEmail = templateData.bcc && templateData.bcc.length > 0 ? mailApi.getContractItemByEmail(mailStrListDecode(templateData.bcc), 'bcc') : Promise.resolve([]);
    return Promise.all([contractItemByEmail, ccContactItemByEmail, bccContactItemByEmail]).then((r) => {
        const res = r[0].concat(r[1], r[2]);
        res.forEach(it => {
            if (it && it.contactItem.contactItemVal && it.contactItem.contactItemVal.length > 0) {
                mailContentModel.receiver.push(it);
            }
        });
        return mailContentModel;
    });
}
